module.exports = __webpack_public_path__ + "img/cupcake-1.a8bd1052.svg";